import { Outlet } from 'react-router-dom'
import { ButtonIcon, ModalProps, ModalRush } from '@/ui'
import { XClose } from '@/icons'

export const AccountLayout = (props: ModalProps) => {
  return (
    <ModalRush {...props} className="relative p-0">
      <ButtonIcon
        className="fixed right-5 top-9 z-30"
        size="xs"
        variant="outline"
        color="secondary"
        onClick={props.onClose}
      >
        <XClose />
      </ButtonIcon>
      <div className="flex size-full min-w-[800px] ">
        <div className="w-full items-center overflow-y-auto">
          <div className="mx-auto flex w-full max-w-[1144px] flex-col gap-4 px-4 pt-12 2xl:pt-3">
            <Outlet />
          </div>
        </div>
      </div>
    </ModalRush>
  )
}
